<template>
  <v-container fluid>
    <v-card class="overflow-auto" max-height="760">
      <!-- light -->
      <v-row>
        <v-col class="pa-0">
          <i-card-vertical header-title="Light">
            <template v-slot:body>
              <v-row>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="lightPrimary">
                      <div class="i_title--text py-3">primary</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ lightPrimary }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="lightSecondary">
                      <div class="i_title--text py-3">secondary</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ lightSecondary }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="lightThird">
                      <div class="i_title--text py-3">third</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ lightThird }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="lightAccent">
                      <div class="i_title--text py-3">accent</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ lightAccent }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="lightBase">
                      <div class="i_title--text py-3">base</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ lightBase }}</div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="lightTextMain">
                      <div class="i_sub_title--text py-3">i_title</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ lightTextMain }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="lightTextSub">
                      <div class="i_title--text py-3">i_sub_title</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ lightTextSub }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="lightError">
                      <div class="i_title--text py-3">error</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ lightError }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="lightSuccess">
                      <div class="i_title--text py-3">success</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ lightSuccess }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="lightWarning">
                      <div class="i_title--text py-3">warning</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ lightWarning }}</div>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </i-card-vertical>
        </v-col>
      </v-row>

      <!--  Dark  -->
      <v-row>
        <v-col class="pa-0">
          <i-card-vertical header-title="Dark">
            <template v-slot:body>
              <v-row>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="darkPrimary">
                      <div class="white--text py-3">primary</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ darkPrimary }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="darkSecondary">
                      <div class="white--text py-3">secondary</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ darkSecondary }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="darkThird">
                      <div class="white--text py-3">third</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ darkThird }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="darkAccent">
                      <div class="white--text py-3">accent</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ darkAccent }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="darkBase">
                      <div class="white--text py-3">base</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ darkBase }}</div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="darkTextMain">
                      <div class="i_sub_title--text py-3">i_title</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ darkTextMain }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="darkTextSub">
                      <div class="i_title--text py-3">i_sub_title</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ darkTextSub }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="darkError">
                      <div class="i_title--text py-3">error</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ darkError }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="darkSuccess">
                      <div class="i_title--text py-3">success</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ darkSuccess }}</div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card elevation="3" class="pa-2">
                    <v-card class="text-center py-3 px-5" :color="darkWarning">
                      <div class="i_title--text py-3">warning</div>
                    </v-card>
                    <div class="text-right px-2 py-1">{{ darkWarning }}</div>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </i-card-vertical>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import iCardVertical from '@/components/common/iCardVertical.vue'

export default {
  name: 'Colors',
  components: {
    'i-card-vertical': iCardVertical
  },
  created() {
    this.lightPrimary = this.$vuetify.theme.themes.light.primary
    ;(this.lightSecondary = this.$vuetify.theme.themes.light.secondary),
      (this.lightThird = this.$vuetify.theme.themes.light.third),
      (this.lightAccent = this.$vuetify.theme.themes.light.accent),
      (this.lightTextMain = this.$vuetify.theme.themes.light.i_title),
      (this.lightTextSub = this.$vuetify.theme.themes.light.i_sub_title),
      (this.lightBase = this.$vuetify.theme.themes.light.base),
      (this.lightError = this.$vuetify.theme.themes.light.error),
      (this.lightSuccess = this.$vuetify.theme.themes.light.success),
      (this.lightWarning = this.$vuetify.theme.themes.light.warning)
  },
  data: () => ({
    //light
    lightPrimary: '',
    lightSecondary: '',
    lightThird: '',
    lightAccent: '',
    lightTextMain: '',
    lightTextSub: '',
    lightBase: '',
    lightError: '',
    lightSuccess: '',
    lightWarning: ''
  })
}
</script>
